import CSS_CLASS from '../../constants/cssClass'
import ICON from '../../constants/icon'
import getContainerContent from '../../container/getContainerContent'
import closeSidebar from '../../sidebar/closeSidebar'
import addUserSnippet from '../../snippet/addUserSnippet'
import renderSnippet from '../../snippet/renderSnippet'
import { Alert } from '../Alert'

export function SaveContainer() {
  const id = 'btn-save-container'
  const keditor =
    window.KEditor.instances[Object.keys(window.KEditor.instances)[0]]
  const { contentAreasWrapper } = keditor

  const createSnippet = (content, localSnippetId) =>
  {
    const templateList = JSON.parse(
      localStorage.getItem('@mf/templates') ?? '[]'
    )
    templateList.push({
      id: localSnippetId,
      ...content,
    })
    localStorage.setItem('@mf/templates', JSON.stringify(templateList))

    Alert({
      message: 'Bloco salvo com sucesso!',
    })
  }

  const addSnippet = (title, content, snippetId, localSnippetId) => {
    const [snippetPreviewHtml, snippetContentHtml] = renderSnippet.call(
      keditor,
      'container',
      title,
      'bundle/assets/icons/custom_html.svg',
      '',
      content,
      [`data-keditor-snippet-id="${snippetId}"`, `data-local-snippet-id="${localSnippetId}"`],
      CSS_CLASS.SNIPPET_COLUMN_2
    )

    keditor.sidebarLeft
      .find(`.${CSS_CLASS.SNIPPETS}`)
      .append(snippetPreviewHtml)
    keditor.sidebarLeft
      .find(`.${CSS_CLASS.SIDEBAR_LEFT_BODY}`)
      .append(snippetContentHtml)
  }

  const save = (container, title) =>
  {
    let localSnippetId = new Date().getTime()

    const containerContent = getContainerContent.call(keditor, container, container.hasClass(CSS_CLASS.SUB_CONTAINER))

    const newContainer = $(containerContent)

    newContainer.find('.custom-container').removeAttr('id')

    const handleRemoveClass = (element) => {
      element.removeClass(
        `keditor-ui keditor-component-content ${CSS_CLASS.CONTAINER_CONTENT} ${CSS_CLASS.SUB_CONTAINER_CONTENT} ${CSS_CLASS.SORTABLE} ${CSS_CLASS.RESIZABLE}`
      )
      const elementChildren = element.children()

      if (elementChildren.length > 0) {
        elementChildren.each(function () {
          const child = $(this)
          return handleRemoveClass(child)
        })
      }
    }

    handleRemoveClass(newContainer)

    newContainer.find('.keditor-toolbar-container-content').remove()
    newContainer.find('.keditor-toolbar').remove()

    newContainer.attr('data-local-snippet-id', localSnippetId)

    const component = {
      title,
      template: window.html`<div
        data-type="container"
        data-nav-tab="blocks"
        data-preview="bundle/assets/icons/custom_html.svg"
        data-keditor-title="${title}"
        data-keditor-categories="Testemonials"
      >
        ${newContainer.prop('outerHTML')}
      </div>`,
    }

    addUserSnippet.call(this, component.template, title, function(success, newComponent) {
      if (success)
      {
        let template = $(newComponent.template);

        template.attr('data-keditor-snippet-id', newComponent.id);

        createSnippet({
          title: newComponent.title,
          template: template.prop('outerHTML'),
        }, localSnippetId)
        addSnippet(title, newContainer.prop('outerHTML'), newComponent.id, localSnippetId)
      }
    })
  }

  contentAreasWrapper.on('click', `#${id}`, function (e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    const btn = $(e.target)
    const container = btn.closest(`.${CSS_CLASS.CONTAINER}`)

    setTimeout(() => {
      closeSidebar.call(keditor)
    }, 50)

    const componentName = prompt(
      'Defina um nome para esse componente que deseja salvar nos seus favoritos: '
    )

    if (componentName.length === 0) {
      return alert(
        'O componente não pode ser salvo com um titulo vazio. Tente novamente.'
      )
    }
    if (componentName === null) return

    save(container, componentName)
  })

  return window.html`
      <a
        id="${id}"
        href="javascript:void(0);"
        class="${CSS_CLASS.UI} ${CSS_CLASS.CONTAINER_BOOKMARK}"
        title="Salvar"
        >${ICON.SAVE}</a
      >
    `
}
